document.addEventListener("DOMContentLoaded", function () {
  $(document).ready(function () {
    // работа в компании
    $(".vacancy__collapser").on("click", function () {
      $(this).toggleClass("active");
      //
      $(this)
        .find("span")
        .text(
          $(this).find("span").text() == "Свернуть" ? "Подробнее" : "Свернуть"
        );
      // $('.vacancy__collapser .vacancy__less').toggleClass('vacancy__more');
      $(this)
        .parents(".vacancies__item")
        .find(".vacancy__content")
        .slideToggle(150);
      $(this).parents(".vacancy").toggleClass("isOpened");
    });
    // faq
    $(".faq__collapser").on("click", function (e) {
      $(e.currentTarget)
        .toggleClass("active")
        .parents(".faq__item")
        .find(".faq__content")
        .slideToggle(150);
    });
    // Parks solution new
    $(".solution-funcs-accordion-item__collapser").on("click", function (e) {
      $(e.currentTarget)
        .toggleClass("is--active")
        .parents(".solution-funcs-accordion-item")
        // .toggleClass("is--open")
        .find(".solution-funcs-accordion-item__content")
        .slideToggle(150);
    });
    // доставка
    // $(".info-delivery__collapser").on("click", function () {
    //   $(this).toggleClass("active");
    //   $(this)
    //     .parents(".info-delivery__item")
    //     .find(".info-delivery__collapse")
    //     .slideToggle(150);
    // });

    $("#rubric-down").on("click", function () {
      $(".news").css({ backgroundColor: "rgba(0, 0, 0, 0.1)" });
      var c = parseInt($(this).data("count-news"), 10);
      var t = parseInt($(this).data("total-news"), 10);
      var pp = parseInt($(this).data("per_page-news"), 10);
      var link = $(this).data("archive-news") || "/news1/";
      var r = c + pp < t ? c + pp : t;
      $(this).data("count-news", r);

      $.ajax({
        method: "GET",
        type: "html",
        url: link + "?pp=" + r,
        success: function (result) {
          $(".news .news__wrap.rows").html(result);
          $(".news").css({ backgroundColor: "rgba(0, 0, 0, 0.0)" });
          if (c + pp >= t) {
            $("#rubric-down").hide();
          }
        },
      });
    });
  });
});
